import { createRefetchContainer, graphql } from 'react-relay';
import MpTemplate from './MpTemplateComponent';

export default createRefetchContainer(MpTemplate, {
  node: graphql`
    fragment MpTemplateContainer_node on MpTemplate {
      id
      title
      description
      notes
      can_edit
      public
      brand {
        id
        logo_url
        header
      }
      mp_template_playlists(first: 99999) @connection(key: "MpTemplateContainer_mp_template_playlists") {
        edges {
          node {
            id
            title
            description
            thumbnail(width: 240, height: 240) {
              url
              width
              height
            }
            num_songs
          }
        }
      }
    }
  `,
  viewer: graphql`
  fragment MpTemplateContainer_viewer on User {
    id
    first_name
    last_name
    primary_brand {
      id
      header
      logo_url
    }
    ...MpTemplatePlaylistContainer_viewer
    ...SearchContainer_viewer
  }
  `,
},
graphql`
  query MpTemplateContainer_RefetchQuery($id: ID!) {
    node(id: $id) {
      ... on MpTemplate {
        id
      }
    }
  }
`
);



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/MpTemplateContainer.js